import InfoIcon from "@mui/icons-material/InfoOutlined";
import {
  Box,
  IconTypeMap,
  SxProps,
  Theme,
  Tooltip,
  TooltipProps,
} from "@mui/material";

export type TInfoTooltipProps = Omit<TooltipProps, "children"> & {
  textAriaLabel?: string;
  size?: IconTypeMap["props"]["fontSize"];
  tabIndex?: number;
  iconStyles?: SxProps<Theme>;
};

const InfoTooltip = (props: TInfoTooltipProps) => {
  const {
    textAriaLabel,
    size = "small",
    tabIndex = 0,
    iconStyles,
    ...tooltipProps
  } = props;

  return (
    <Tooltip arrow {...tooltipProps}>
      <Box tabIndex={tabIndex} component="span" role="note">
        <InfoIcon
          fontSize={size}
          color="action"
          sx={iconStyles}
          aria-label={textAriaLabel}
        />
      </Box>
    </Tooltip>
  );
};

export default InfoTooltip;
